import { connect } from 'react-redux';
import getContentAction from '../../actions/get-content/get-content';
import Component from './component';

const mapStateToProps = state => ({
    content: state.content.get('content'),
    selectproduct: state.selectproduct.get('selectproduct'),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    handleRefresh: async () => {
        await dispatch(await getContentAction());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
